//AUTHENTICATION
export const BASE_URL = `https://app-57866.dc-us-1.absamcloud.com/api`;
export const AUTH_LOGIN = `${BASE_URL}/auth/login`;
export const USER_INFO = `${BASE_URL}/auth/user`;
export const AUTH_LOGOUT = `${BASE_URL}/auth/logout`;

//DASHBOARD
export const DASHBOARD = `${BASE_URL}/auth/dashboard`;

//CUSTOMERS
export const CUSTOMERS = `${BASE_URL}/auth/customers`;

//CUSTOMERS_NOTIFICATIONS
export const CUSTOMERS_NOTIFICATIONS = `${BASE_URL}/auth/customers-notifications`;

//CUSTOMERS_NOTIFY_TODAY
export const CUSTOMERS_NOTIFY_TODAY = `${BASE_URL}/auth/customers-notifications`;

//PRODUCTS
export const PRODUCTS = `${BASE_URL}/auth/products`;

//CATEGORIES
export const CATEGORIES = `${BASE_URL}/auth/categories`;

//ORDER
export const ORDER = `${BASE_URL}/auth/orders`;

//ORDER-PRODUCTS
export const ORDER_PRODUCTS = `${BASE_URL}/auth/orders-products`;
